export class ContentBusinessType {
  id: any;
  acPickerLogo: any;
  businessTravelerDisplayText: any;
  businessLoginDisplayText: any;
  personalTravelerDisplayText: any;
  personalLoginDisplayText: any;
  adminLoginDisplayText: any;
  adminLoginUrl: any;
  nuTravelAdminLoginUrl: any;
  learnMoreText: string;
  loginPickerContinueBtnText: any;
  chooseAccountDisplayText: any;
  chooseAccountDisclaimer: any;
  logOutDisplayText: any;
  businessLogoutUrl: any;
  BBIZ: any;
  CRG3: any;
  CRAM: any;
  SKYB: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['acPickerLogo']) {
        this.acPickerLogo = contentjson['acPickerLogo'];
      }
      if (contentjson['personalTravelerDisplayText']) {
        this.personalTravelerDisplayText =
          contentjson['personalTravelerDisplayText'];
      }
      if (contentjson['businessLoginDisplayText']) {
        this.businessLoginDisplayText = contentjson['businessLoginDisplayText'];
      }
      if (contentjson['businessTravelerDisplayText']) {
        this.businessTravelerDisplayText =
          contentjson['businessTravelerDisplayText'];
      }
      if (contentjson['personalLoginDisplayText']) {
        this.personalLoginDisplayText = contentjson['personalLoginDisplayText'];
      }
      if (contentjson['adminLoginDisplayText']) {
        this.adminLoginDisplayText = contentjson['adminLoginDisplayText'];
      }
      if (contentjson['adminLoginUrl']) {
        this.adminLoginUrl = contentjson['adminLoginUrl'];
      }
      if (contentjson['nuTravelAdminLoginUrl']) {
        this.nuTravelAdminLoginUrl = contentjson['nuTravelAdminLoginUrl'];
      }
      if (contentjson['chooseAccountDisplayText']) {
        this.chooseAccountDisplayText = contentjson['chooseAccountDisplayText'];
      }
      if (contentjson['chooseAccountDisclaimer']) {
        this.chooseAccountDisclaimer = contentjson['chooseAccountDisclaimer'];
      }
      if (contentjson['learnMoreText']) {
        this.learnMoreText = contentjson['learnMoreText'];
      }
      if (contentjson['logOutDisplayText']) {
        this.logOutDisplayText = contentjson['logOutDisplayText'];
      }
      if (contentjson['businessLogoutUrl']) {
        this.businessLogoutUrl = contentjson['businessLogoutUrl'];
      }
      if (contentjson['loginPickerContinueBtnText']) {
        this.loginPickerContinueBtnText =
          contentjson['loginPickerContinueBtnText'];
      }
      if (contentjson['BBIZ']) {
        this.BBIZ = contentjson['BBIZ'];
      }
      if (contentjson['CRG3']) {
        this.CRG3 = contentjson['CRG3'];
      }
      if (contentjson['CRAM']) {
        this.CRAM = contentjson['CRAM'];
      }
      if (contentjson['SKYB']) {
        this.SKYB = contentjson['SKYB'];
      }
    }
  }
}
